import { initGlobalState, MicroAppStateActions } from 'qiankun'
// 公共数据存放
const initState = {
  // appLoading: true,
  appRouter: '',
  isCollapse: false,
  theme: false  // 新增：主题状态
}
const actions = initGlobalState(initState)

export default actions
